export enum ServerName {
  Hybris = 'Hybris',
  Mashery = 'Mashery',
  Local = 'Local',
  server360 = 'server360',
  Okta = 'Okta'
}
